import { useRef, useEffect, useCallback, PropsWithChildren, FC, useState } from 'react'
import { Select, Spin } from 'antd'
import CardContainer from '@/pages/Bmjy/components/components/CardContainer'
import GbmndtjBgjz from './GbmndtjBgjz'
import GbmndtjBgfs from './GbmndtjBgfs'

const tabsOptions = [
  {
    label: '按院', 
    value: 'ay',
    api: null
  }, 
  {
    label: '按所', 
    value: 'as',
    api: null
  }
]

type PropType = FC<PropsWithChildren<{
  updateTime: string
}>>

const Component: PropType = ({updateTime}) => {
  const [reportType, setReportType] = useState('bgjz')
  const [tabActive, setTabActive] = useState('')



  // 变更类型
  const handleTabChange = useCallback((value) => {
    setTabActive(value.tab)
  }, [])

  return (
    <CardContainer
      tabs={tabsOptions}
      onTabChange={handleTabChange}
      title='各部门年度统计'
      customFilter={
        <div className='ml-10'>
          <Select value={reportType} onChange={setReportType} size='small'>
            <Select.Option value="bgjz">报告价值</Select.Option>
            <Select.Option value="bgfs">报告份数</Select.Option>
          </Select>
        </div>
      }
    >
      <div className='h-full pt-20'>
        {
          reportType === 'bgjz' && <GbmndtjBgjz updateTime={updateTime} tabActive={tabActive} />
        }
        {
          reportType === 'bgfs' && <GbmndtjBgfs updateTime={updateTime} tabActive={tabActive} />
        }
      </div>
    </CardContainer>
  )
}

export default Component
